import React from "react";

import AnswerCheckBox from "./answer-checkbox";

const CreateNewAnswer = (props) => {
	const { onAdd, onAddOther, haveOtherOption } = props;
	return (
		<div className="answer-options">
			<AnswerCheckBox {...props} />
			<div className="field field-input" onClick={onAdd}>
				<span className="add-new">Добавить вариант</span>
				{haveOtherOption || (
					<>
						<span className="spacer"> или </span>
						<span
							className="add-other"
							onClick={(e) => {
								e.stopPropagation();
								onAddOther();
							}}
						>
							добавить вариант “Другое”
						</span>
					</>
				)}
			</div>
		</div>
	);
};

export default CreateNewAnswer;
